/**
 * Used in the conversion of a v1 job to a v2 job, where a value has no v1 equivalent, e.g. the ID
 * of a relation.
 */
export const NOT_CAPTURED = 'NOT_CAPTURED';

/**
 * Used in the conversion between a v1 job and a v2 job, where a mapping of values returns no match.
 */
export const NOT_FOUND = 'NOT_FOUND';

/**
 * Represents the primary HCP on a job.
 */
export const HCP1 = 'HCP1';

/**
 * Represents the buddy HCP on a job.
 */
export const HCP2 = 'HCP2';
